import { Stack } from '@mui/material';
import classNames from 'classnames';
import { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import Select from '/@/v3/components/forms/select';
import NOLStyles from '../styles.module.css';
import styles from './styles.module.css';

function NOLMapValue({ mapMapValues }) {
    const [version, setVersion] = useState(mapMapValues[0]);

    const options = mapMapValues.map((mapValue) => ({
        label: _(mapValue.map.versionLabel),
        value: mapValue.map.id,
    }));

    const setNewVersion = (versionId) => {
        const newVersion = mapMapValues.find((mapValue) => mapValue.map.id === versionId);
        setVersion(newVersion);
    };

    return (
        <div className={styles.mapValueContainer} key={version.id}>
            <div className={styles.mapValue}>
                <div className={styles.col}>
                    <div className={classNames(styles.mapName, styles.row)}>{_(version.map.name)}</div>
                    <div className={styles.row}>
                        <span>{_('Unidad')}: </span>
                        <ReactMarkdown className={styles.unitMd}>{_(version.map.referenceUnit)}</ReactMarkdown>
                    </div>
                </div>
                <div className={styles.col}>
                    <div>
                        <Select
                            color={settings.app.theme}
                            appearance='outline'
                            clearable={false}
                            value={version.map.id}
                            options={options}
                            onChange={(v) => setNewVersion(v)}
                            disabled={version.length === 0}
                        />
                    </div>
                    <div className={styles.rowContainer}>
                        <div
                            className={classNames(
                                styles.value,
                                styles.row,
                                version.value.length < 10 && styles.versionWidth
                            )}
                            style={{ backgroundColor: `#${version.color}` }}
                        >
                            {version.value}
                        </div>
                    </div>
                </div>
            </div>
            <hr className={NOLStyles.border} />
        </div>
    );
}

function NOLMapValues({ mapValues }) {
    return (
        <Stack
            direction='column'
            sx={{
                overflow: 'auto',
                flex: 1,
                minHeight: 0,
            }}
        >
            {Object.keys(mapValues).map((mapSlug) => (
                <NOLMapValue mapMapValues={mapValues[mapSlug]} key={mapSlug} />
            ))}
        </Stack>
    );
}

export default NOLMapValues;
